import HttpFactory from '@/mixins/http.factory';
export default {
	name: 'confirm-dialog-monday',
	mixins:[HttpFactory],
	data () {
		return {
			mondayInfo:null,
			msg:null,
			data:null,
			loading:false
		}
	},
	created(){
		this.init();
	},
	methods:{
		async init(){
			let _self=this;
			let data= await _self.fn().getMondayData_Child(_self.$route.params.appId,_self.$route.params.installationId);
			_self.mondayInfo = data;
			
			var triggerInstance;
			if(this.$route.query.hdItemId && this.$route.query.cacheReset)
				triggerInstance=`confirm-dialog_md${this.$route.query.hdItemId}_cacheReset`
			else if(this.$route.query.hdItemId && this.$route.query.workItemId)
				triggerInstance=`confirm-dialog_md${this.$route.query.hdItemId}_wd${this.$route.query.workItemId}`
			else if(this.$route.query.hdItemId && this.$route.query.issueId)
				triggerInstance=`confirm-dialog_md${this.$route.query.hdItemId}_wd${this.$route.query.issueId}`
			else if(this.$route.query.hdItemId && this.$route.query.taskId)
				triggerInstance=`confirm-dialog_md${this.$route.query.hdItemId}_wd${this.$route.query.taskId}`
			else if(this.$route.query.fileId)
				triggerInstance=`confirm-dialog_file${this.$route.query.fileId}`

			_self.mondayInfo=await _self.fn().getMondayData_Child(_self.$route.params.hdBoardId,_self.$route.params.hdItemId);
			_self.msg=_self.mondayInfo.msg;
		},
		confirmButtonClick(){
			let _self=this;
			let response={type:'confirmed',Success:true};
			_self.sendDataToParent(response);
		},
		closeDialog(data) {
			let _self = this;
			let response=data?data:{Success:false};
			_self.fn().close_monday_modal(response);
		},
		sendDataToParent(data) {
			let _self = this;
			this.loading=true;	
			var triggerInstance;
			if(this.$route.query.hdItemId && this.$route.query.cacheReset)
				triggerInstance=`remove-confirm-dialog_md${this.$route.query.hdItemId}_cacheReset`
			else if(this.$route.query.hdItemId && this.$route.query.workItemId)
				triggerInstance=`remove-confirm-dialog_md${this.$route.query.hdItemId}_wd${this.$route.query.workItemId}`
			else if(this.$route.query.hdItemId && this.$route.query.issueId)
				triggerInstance=`remove-confirm-dialog_md${this.$route.query.hdItemId}_wd${this.$route.query.issueId}`
			else if(this.$route.query.hdItemId && this.$route.query.taskId)
				triggerInstance=`remove-confirm-dialog_md${this.$route.query.hdItemId}_wd${this.$route.query.taskId}`
			else if(this.$route.query.fileId)
				triggerInstance=`remove-confirm-dialog_file${this.$route.query.fileId}`
				
			_self.closeDialog(data);

		}
	}
}

